<section class="nw_service_th" *ngIf="!loader && businessListData.length > 0">
    <div class="service_se">
        <div class="heading_sert">
            <h3> All employees </h3>
        </div>
        <div class="chip_services_list">
            <mat-chip-list class="example-chip">
                <mat-chip (click)="selectBusiness(i)" *ngFor="let item of businessListData; let i =index" [ngClass]="{'Graceful-box-active': item.isSelected == 1}" >{{item.name}}</mat-chip>
           </mat-chip-list>
        </div>
    </div>

    <div class="service_create_sd" style="border-bottom: 1px solid #ddd;margin-bottom: 20px;">
    <div class="row" >
        <div class="col-sm-10">
           <div class="serv_heading">
            <h3>Employees of {{selectedBusiness.name}}</h3>
            <p>{{selectedBusiness.address_line}}</p>

        </div>
      </div>
      <div class="col-sm-2">
        <div class="create_btn_sd">
            <button mat-flat-button color="primary" (click)="employeeplan()" >
                <mat-icon>add</mat-icon> 
                Add new employee
            </button>
        </div>
      </div>
    </div>
    </div>

    <div class="service_card_sedf" *ngIf="employeeData.length > 0 && !hidediv">
        <div class="row">
            <div class="col-sm-3" *ngFor="let item of employeeData">
                <div class="serv_sect">
                <mat-card class="service-card" >
                 <mat-card-header class="hy_secf">
                <div mat-card-avatar class="header-avatar">
                    <div class="active_user" *ngIf="item.status == 1"></div>
                    <div class="de_active_user" *ngIf="item.status == 0"></div>
                    <img [src]="item.imgThumbUrl" alt="" onerror="this.src='../../../../assets/images/user-avatar.svg'">
                </div>
                <button mat-icon-button [matMenuTriggerFor]="menu2" class="more-button" aria-label="More options">
                    <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu2="matMenu">
                    <button mat-menu-item (click)="newemployeedetails(item)">
                        <mat-icon class="material-icons-outlined">info</mat-icon>
                        <span>View details</span>
                    </button>
                    <button mat-menu-item (click)="openMessages(item,$event)"> 
                        <mat-icon class="material-icons-outlined">chat</mat-icon>
                        <span>Send messages</span>
                    </button>
                </mat-menu>
            </mat-card-header>
            <mat-card-content>
                <div class="header_ftgt">
                    <h4>{{item.name}}</h4>
                    <mat-card-subtitle>{{ item.country_code }} {{item.phone}}</mat-card-subtitle>
                </div>
            <div class="location_list_s">
            <div class="new_empol">
                <p style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"> <mat-icon>location_on</mat-icon> {{item.addline}}</p>
            </div>
            <div class="new_empol">
                <p> <mat-icon style="color: #434343;">calendar_month</mat-icon> {{item.dateOfJoin | date}} (DOJ)</p>
            </div>
            </div>
                <!-- <div class="subscription_status" >
                    <p class="active_heading" *ngIf="item.subscriptionInfo">Active subscription</p>
                      <p class="expired_heading" *ngIf="!item.subscriptionInfo">Subscription expired</p>
                     </div> -->
                <!-- <div class="chip_oper">
                <mat-accordion>
                 <mat-expansion-panel  (opened)="panelState[0] = true"
                                      (closed)="panelState[0] = false">
                   <mat-expansion-panel-header>
                     <mat-panel-title>
                    <div class="subscription_status"  >
                    <p class="active_heading" *ngIf="item.subscriptionInfo">Active subscription</p>
                      <p class="expired_heading" *ngIf="!item.subscriptionInfo">Subscription expired</p>
                     </div>
                     <div class="jb_headingtert" >
                       <p> Jobs</p>
                     </div>
                     </mat-panel-title>
                    
                   </mat-expansion-panel-header>
                   <div *ngIf="item.assigned_slots">

                     <div class="main_time_till" >
                       <div class="time-pill" *ngFor="let item of item.formatted_assigned_slots">
                         <div class="count-circle">{{ item.count }}</div>
                         <div class="time-text">{{ item.start_time.slice(0,5) }} - {{ item.end_time.slice(0,5) }}</div>
                        </div>
                        
                      </div>
                    </div>
                    <div *ngIf="!item.assigned_slots" style="display: flex;justify-content: center;color: grey;">
                      <p>No assigned jobs yet.</p>
                    </div>
                 </mat-expansion-panel>


                 </mat-accordion>

            </div> -->


             <div class="chip_oper" (click)="$event.stopPropagation()">
              <mat-accordion>
                <!-- (opened)="panelState[0] = true" (closed)="panelState[0] = false" -->
                 <mat-expansion-panel hideToggle >
                   <mat-expansion-panel-header>
                     <div class="emolpyee_down_list">
                        <div class="emplyee_listy" style="width: 150px;">
                     <mat-panel-title>
                    <div class="subscription_status"  >
                    <p class="active_heading" *ngIf="item.subscriptionInfo">Active subscription</p>
                      <p class="expired_heading" *ngIf="!item.subscriptionInfo">Subscription expired</p>
                     </div>
                     <!-- <div class="jb_headingtert" >
                       <p> Jobs</p>
                     </div> -->
                     </mat-panel-title>
                     </div>
                     <div class="emplyee_listy">
                       <mat-panel-description>
                           Jobs ({{item.assigned_slots ? item.assigned_slots.length : 0}})
                           <mat-icon>keyboard_arrow_down</mat-icon>
                           </mat-panel-description>
                           </div>
                           </div>
                   </mat-expansion-panel-header>
                   <div *ngIf="item.assigned_slots">

                     <div class="main_time_till" >
                       <div class="time-pill" *ngFor="let item of item.formatted_assigned_slots">
                         <div class="count-circle">{{ item.count }}</div>
                         <div class="time-text">{{ item.start_time.slice(0,5) }} - {{ item.end_time.slice(0,5) }}</div>
                        </div>
                        
                      </div>
                    </div>
                    <div *ngIf="!item.assigned_slots" style="display: flex;justify-content: left;color: grey;">
                      <p>No assigned jobs yet.</p>
                    </div>
                 </mat-expansion-panel>

 <!-- <mat-expansion-panel  hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-title>
      <div class="subscription_status"  >
                    <p class="active_heading" *ngIf="item.subscriptionInfo">Active subscription</p>
                      <p class="expired_heading" *ngIf="!item.subscriptionInfo">Subscription expired</p>
                     </div>
      </mat-panel-title>
      <mat-panel-description>
       Assignments
        <mat-icon>keyboard_arrow_down</mat-icon>
      </mat-panel-description>
    </mat-expansion-panel-header>
  <div *ngIf="item.assigned_slots">

                     <div class="main_time_till" >
                       <div class="time-pill" *ngFor="let item of item.formatted_assigned_slots">
                         <div class="count-circle">{{ item.count }}</div>
                         <div class="time-text">{{ item.start_time.slice(0,5) }} - {{ item.end_time.slice(0,5) }}</div>
                        </div>
                        
                      </div>
                    </div>
                    <div *ngIf="!item.assigned_slots" style="display: flex;justify-content: center;color: grey;">
                      <p>No assigned jobs yet.</p>
                    </div>
 
  </mat-expansion-panel> -->

                 </mat-accordion>
            </div>

          
            <!-- <div class="chuo_list">
                <div class="send_btnrt">
                    <button (click)="openMessages(item,$event)" mat-flat-button>Send messages</button>
                </div>
            <div class="onhover_arrow">
                <mat-icon class="hover-icon"> arrow_forward</mat-icon>
           </div>
        </div> -->
            </mat-card-content>

        </mat-card>
    </div>
    </div>

    
    </div>
    </div>


        <!-- Placeholder design html start -->
        <div class="placeholder_started" *ngIf="employeeData.length == 0 && !hidediv">
            <div class="row">
            
              <!-- <div class="col-sm-4">
                <div class="dashboard_new">
                  <mat-card>
                      <div class="upload_sectio">
                     <div class="icm_img">
                        <img src="./assets/images/employee-placeholder.jpg">
                     </div>
                     <mat-card-title>No business added yet yet</mat-card-title>
                     <mat-card-content>Your employees will appear hear. For that you need to create a business first. It's easy and takes only 2 minutes.
                    </mat-card-content>
                     <div class="create_btnyh">
                        <button mat-flat-button color="primary">
                            <mat-icon>add</mat-icon> 
                            Add new employees
                        </button>
                     </div>
                     </div>
                  </mat-card>
               </div>
              </div> -->
              <div class="col-sm-4">
                <div class="dashboard_new">
                  <mat-card>
                      <div class="upload_sectio">
                     <div class="icm_img">
                        <img src="./assets/images/employee-paceholder.png">
                     </div>
                     <mat-card-title>No employees to show</mat-card-title>
                     <mat-card-content>You haven't added any employees yet. Once you start adding them, the list of employees will appear here with details.
                    </mat-card-content>
                     <div class="watch_vc_btn">
                        <button mat-stroked-button color="primary" (click)="employeeplan()">
                           <mat-icon>add</mat-icon>
                          Add new employee
                        </button>
                     </div>
                     </div>
                  </mat-card>
               </div>
              </div>
              <div class="col-sm-4">
                <div class="dashboard_new">
                  <mat-card>
                      <div class="upload_sectio">
                     <div class="icm_img">
                        <img src="./assets/images/add-employee.png">
                     </div>
                     <mat-card-title>How to add employees?
                    </mat-card-title>
                     <mat-card-content>Check our <span class="ghtunderline" (click)="openLink('https://lookzup.com/help')"> help document </span> on adding employees in a business. You can check this video as well. 
                    </mat-card-content>
                     <div class="watch_vc_btn">
                        <button mat-stroked-button color="primary" (click)="openvideo()">
                           <mat-icon>play_arrow</mat-icon>
                           Watch video
                        </button>
                     </div>
                     </div>
                  </mat-card>
               </div>
              </div>
              <div class="col-sm-4">
                <div class="dashboard_new">
                  <mat-card>
                      <div class="upload_sectio">
                     <div class="icm_img">
                        <img src="./assets/images/helpsupport.png">
                     </div>
                     <mat-card-title>Having any issue?</mat-card-title>
                     <mat-card-content>For any difficulties in displaying data here or if there's any issue while adding employees, contact our support team.
                    </mat-card-content>
                     <div class="watch_vc_btn">
                        <button mat-stroked-button color="primary" (click)="opencontact()">
                           <mat-icon>support_agent</mat-icon>
                           Contact support
                        </button>
                     </div>
                     </div>
                  </mat-card>
               </div>
              </div>
            </div>
        
          </div>
          <!-- Placeholder design html start -->

</section>
<section class="nw_service_th" *ngIf="!loader && businessListData.length == 0">`



        <!-- Placeholder design html start -->
        <div class="placeholder_started">
            <div class="row">
                <div class="heading_sert">
                    <h3>Employees</h3>
                </div>
              <div class="col-sm-4" *ngIf="!isEmployeeAndHasBusinessButDoesNotHaveAccess">
                <div class="dashboard_new">
                  <mat-card>
                      <div class="upload_sectio">
                     <div class="icm_img">
                        <img src="./assets/images/business-create.png" style="width: 110px;">
                     </div>
                     <mat-card-title>No business added yet</mat-card-title>
                     <mat-card-content>Your employees will appear here. For that you need to create a business first. It's easy and takes only 2 minutes.
                    </mat-card-content>
                     <div class="create_btnyh">
                        <button mat-flat-button color="primary" (click)="selectcountry()">
                            <mat-icon>add</mat-icon> 
                            Create a business
                        </button>
                     </div>
                     </div>
                  </mat-card>
               </div>
              </div>
              <div class="col-sm-4" *ngIf="isEmployeeAndHasBusinessButDoesNotHaveAccess">
                <div class="dashboard_new" >
                  <mat-card appearance="outlined" style="">
                      <div class="upload_sectio">
                     <div class="icm_img">
                        <img src="./assets/images/business-create.png" style="width: 110px;">
                     </div>
                     <mat-card-title>Access denied.</mat-card-title>
                     <mat-card-content> Business owner with valid premium business subscription or an active employee with permission can access this section. Check current plans. Recharge pack if expired.
                    </mat-card-content>
                     
                     </div>
                  </mat-card>
               </div>
              </div>
              <div class="col-sm-4">
                <div class="dashboard_new">
                  <mat-card>
                      <div class="upload_sectio">
                     <div class="icm_img">
                        <img src="./assets/images/employee-paceholder.png">
                     </div>
                     <mat-card-title>No employees to show here</mat-card-title>
                     <mat-card-content>You haven't added any employees yet. Check <span class="ghtunderline" (click)="openLink('https://lookzup.com/help')"> help doc</span> or this video on how to add employees under your business.
                    </mat-card-content>
                     <div class="watch_vc_btn">
                        <button mat-stroked-button color="primary" (click)="openvideo()">
                           <mat-icon>play_arrow</mat-icon>
                           Watch video
                        </button>
                     </div>
                     </div>
                  </mat-card>
               </div>
              </div>
              <div class="col-sm-4">
                <div class="dashboard_new">
                  <mat-card>
                      <div class="upload_sectio">
                     <div class="icm_img">
                        <img src="./assets/images/helpsupport.png">
                     </div>
                     <mat-card-title>Having any issue?</mat-card-title>
                     <mat-card-content>For any difficulties in displaying data here or if there's any issue while adding employees, contact our support team.
                    </mat-card-content>
                     <div class="watch_vc_btn">
                        <button mat-stroked-button color="primary" (click)="opencontact()">
                           <mat-icon>support_agent</mat-icon>
                           Contact support
                        </button>
                     </div>
                     </div>
                  </mat-card>
               </div>
              </div>
            </div>
        
          </div>
          <!-- Placeholder design html start -->

</section>